import React from 'react';

import PropTypes from 'prop-types';
import Select from 'react-select/async';

import SelectDropdown from 'client/common/selects/select-dropdown';
import {SelectCommonProps, SelectOption} from 'client/common/selects/types';

import '../select-dropdown/select-dropdown.scss';

const AsyncDropdown = (props) => {
  const {fetchData, options, cacheOptions = true, ...selectProps} = props;

  const loadOptions = (inputValue, callback) => {
    fetchData(inputValue).then(callback);
  };

  return (
    <SelectDropdown
      {...selectProps}
      cacheOptions={cacheOptions}
      searchable
      options={options}
      Component={Select}
      loadOptions={loadOptions}
    />
  );
};

AsyncDropdown.propTypes = {
  ...SelectCommonProps,
  value: PropTypes.oneOfType([PropTypes.arrayOf(SelectOption), SelectOption, PropTypes.number, PropTypes.string]),
  fetchData: PropTypes.func.isRequired,
};

export default AsyncDropdown;
